import {isEmpty, vuepayAlert} from "../utility";
import {getData, LOGIN} from "../storage";


const handleAPIResponse = (nextProps, successCallback, errorCallback,hideSuccessAlert = false, hideErrorAlert = false) => {

    if (nextProps.tip && nextProps.tip.tipSendResponse) {
        if (nextProps.tip.tipSendResponse.error && nextProps.tip.tipSendResponse.error.status_code === 422) {
            if(!hideSuccessAlert){
                vuepayAlert("error", nextProps.tip.tipSendResponse.error.message);
            }
            errorCallback && errorCallback();
        } else if (nextProps.tip.tipSendResponse.success && nextProps.tip.tipSendResponse.success.status_code === 200) {
            if(!hideErrorAlert){

            }
            nextProps.showTipResponseModal();
            successCallback && successCallback(nextProps.tip.tipSendResponse.success.message);
        }
        nextProps.resetTip();
    }
}

const tipRequest = (props,tipAmount, screen,broadcaster_id,broadcast_id = null,callback) => {

    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {

            if(props.moneyblox.hasOwnProperty("user_details") && props.moneyblox.user_details !==null){
                let requestData = {
                    amount: tipAmount,
                    broadcaster_id: broadcaster_id,
                    initiated_screen: screen,
                    moneyblox: {
                        token: props.moneyblox.user_details.token,
                        api_token: props.moneyblox.user_details.api_token,
                    },
                    device: {
                        platform: props.device.platform,
                        name: props.device.name,
                        version: props.device.version,
                        ip: props.device.ip,
                        id: props.device.id,
                        app_version: props.device.app_version,
                        device_token: props.device.device_token,
                    },
                };

                if (broadcast_id) {
                    requestData["broadcast_id"] = broadcast_id;
                }

                props.sendTip(data.token, data.api_token, requestData);
                callback();
                props.hideTipModal();
            } else {
                window.location.reload();
            }
        }
    });
};

const tipRequestFromClipStore = (props, amount,broadcaster_id, initiated_screen = "clipstore", type, uuid, quick_tip_amount = null, callback) => {

    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {

            if (props.moneyblox.hasOwnProperty("user_details") && props.moneyblox.user_details !== null) {
                let requestData = {
                    amount,
                    broadcaster_id,
                    initiated_screen,
                    type,
                    uuid,
                    moneyblox: {
                        token: props.moneyblox.user_details.token,
                        api_token: props.moneyblox.user_details.api_token,
                    },
                    device: {
                        platform: props.device.platform,
                        name: props.device.name,
                        version: props.device.version,
                        ip: props.device.ip,
                        id: props.device.id,
                        app_version: props.device.app_version,
                        device_token: props.device.device_token,
                    },
                };

                if (quick_tip_amount) {
                    requestData["quick_tip_amount"] = quick_tip_amount;
                }

                props.sendTip(data.token, data.api_token, requestData);
                callback();
                props.hideTipModal();
            } else {
                window.location.reload();
            }
        }
    });
};

export default {
    handleAPIResponse,
    tipRequest,
    tipRequestFromClipStore
}